export default __webpack_public_path__ + "static/media/UAE.d90edfe1.jpg";